export const teamBuilding: Record<string, string> = {
  'teambuilding.title': 'Các đợt Team Building',
  'teambuilding.subtitle': 'Tạo đợt, gán nhân sự vào từng team, chốt và gửi thông báo.',
  'teambuilding.create': 'Tạo đợt',
  'teambuilding.name': 'Tên đợt',
  'teambuilding.eventDate': 'Ngày tổ chức',
  'teambuilding.teamCount': 'Số team',
  'teambuilding.statusCol': 'Trạng thái',
  'teambuilding.status.draft': 'Nháp',
  'teambuilding.status.finalized': 'Đã chốt',
  'teambuilding.notified': 'Đã gửi',
  'teambuilding.notNotified': 'Chưa gửi',
  'teambuilding.open': 'Mở',
  'teambuilding.delete': 'Xoá',
  'teambuilding.deleteConfirm': 'Xoá đợt "{name}"? Không hoàn tác được. Thông báo đã gửi vẫn còn trong chuông của mọi người.',
  'teambuilding.empty': 'Chưa có đợt Team Building nào.',
  'teambuilding.loadError': 'Không tải được đợt này.',
  'teambuilding.back': 'Quay lại danh sách',
  'teambuilding.participants': 'Người tham gia',
  'teambuilding.unassigned': 'Chưa xếp team',
  'teambuilding.emptyColumn': 'Chưa có ai',
  'teambuilding.shuffle': 'Chia ngẫu nhiên',
  'teambuilding.reshuffle': 'Xáo lại',
  'teambuilding.saveRoster': 'Lưu roster',
  'teambuilding.saved': 'Đã lưu',
  'teambuilding.emptyTeamWarning': 'Có team đang trống — thêm người hoặc xáo lại trước khi lưu.',
  'teambuilding.finalize': 'Chốt team',
  'teambuilding.finalizeConfirmTitle': 'Chốt roster?',
  'teambuilding.finalizeConfirmMessage': 'Sau khi chốt, roster sẽ không thể sửa nữa.',
  'teambuilding.notify': 'Gửi thông báo',
  'teambuilding.notifyConfirmTitle': 'Gửi thông báo cho tất cả thành viên?',
  'teambuilding.notifyConfirmMessage': 'Mỗi người sẽ nhận thông báo "Bạn thuộc Team X". Chỉ gửi được một lần.',
  'teambuilding.notifyResult': 'Đã gửi',
  'teambuilding.notifySkipped': 'bỏ qua (không có email)',
  'teambuilding.notifiedAtLabel': 'Đã gửi lúc',
  'teambuilding.locked': 'Roster đã khoá — không thể sửa.',
  'teambuilding.vote.title': 'Bình chọn team xuất sắc',
  'teambuilding.vote.hint': 'Mỗi người 1 phiếu cho 1 team khác team mình, xác nhận 2 lần là cuối cùng, không đổi được. Cần ít nhất 3 team. Mở rồi thì roster khoá; đóng rồi không mở lại.',
  'teambuilding.vote.status.none': 'Chưa mở',
  'teambuilding.vote.status.open': 'Đang mở',
  'teambuilding.vote.status.closed': 'Đã đóng',
  'teambuilding.vote.open': 'Mở bình chọn',
  'teambuilding.vote.close': 'Đóng bình chọn',
  'teambuilding.vote.openConfirmTitle': 'Mở bình chọn?',
  'teambuilding.vote.openConfirmMessage': 'Mọi người trong roster sẽ nhận thông báo kèm link bình chọn. Roster sẽ bị khoá.',
  'teambuilding.vote.closeConfirmTitle': 'Đóng bình chọn?',
  'teambuilding.vote.closeConfirmMessage': 'Kết quả sẽ công bố cho roster và gửi thông báo. Không mở lại được.',
  'teambuilding.vote.turnout': 'Đã bình chọn',
  'teambuilding.vote.sent': 'Đã gửi thông báo',
  'teambuilding.vote.rank': 'Hạng',
  'teambuilding.vote.team': 'Team',
  'teambuilding.vote.votes': 'Phiếu',
  'teamvote.title': 'Bình chọn Team Building',
  'teamvote.empty': 'Bạn chưa có đợt bình chọn nào.',
  'teamvote.yourTeam': 'Team của bạn',
  'teamvote.pick': 'Chọn 1 team khác team của bạn rồi bấm Xác nhận. Xác nhận xong là cuối cùng, không đổi được.',
  'teamvote.yourVote': 'Bạn đang chọn',
  'teamvote.notVoted': 'Bạn chưa bình chọn',
  'teamvote.results': 'Kết quả',
  'teambuilding.vote.duration': 'Thời gian tối đa để bình chọn (phút)',
  'teambuilding.vote.durationHint': 'Để trống = không giới hạn (admin tự đóng). Tối đa 1440 phút. Hết giờ thì không ai bình chọn được nữa, nhưng vẫn phải bấm Đóng để công bố kết quả.',
  'teambuilding.vote.durationPlaceholder': 'Không giới hạn',
  'teambuilding.vote.durationInvalid': 'Nhập số phút nguyên từ 1 đến 1440, hoặc để trống.',
  'teambuilding.vote.deadline': 'Hạn bình chọn',
  'teambuilding.vote.limit': 'Giới hạn',
  'teambuilding.vote.limitMinutes': '{n} phút',
  'teambuilding.vote.timesTitle': 'Tổng thời gian xác nhận của từng team',
  'teamvote.confirmAction': 'Xác nhận',
  'teamvote.confirmTitle': 'Xác nhận bình chọn?',
  'teamvote.confirmMessage': 'Bạn bình chọn cho "{team}". Sau khi xác nhận, bạn KHÔNG đổi lại được và thời điểm xác nhận được ghi nhận.',
  'teamvote.locked': 'Bạn đã xác nhận bình chọn — không đổi được nữa.',
  'teamvote.confirmed': 'Đã xác nhận: {team}',
  'teamvote.expired': 'Đã hết thời gian bình chọn.',
  'teamvote.times': 'Tổng thời gian xác nhận của từng team',
  'teamvote.timeTaken': 'Tổng thời gian',
  'teamvote.incomplete': 'Chưa đủ ({done}/{all})',
  'teamvote.unit.h': 'g',
  'teamvote.unit.m': 'p',
  'teamvote.unit.s': 's',
  'teamvote.open': 'Bình chọn',
  'teamvote.viewResults': 'Xem kết quả',
  'teamvote.close': 'Đóng',
  'teamvote.countdown.label': 'Thời gian còn lại để bình chọn',
  'teamvote.countdown.until': 'Hạn chót',
  'teamvote.countdown.noLimit': 'Không giới hạn thời gian',
  'teamvote.countdown.soon': 'Còn dưới 5 phút',
  'teamvote.countdown.last': 'Còn dưới 1 phút',
  'teamvote.timesHint': 'Bấm vào một team để xem thời gian xác nhận của từng người.',
  'teamvote.memberTime': 'Thời gian xác nhận từng người của {team}',
  'teamvote.memberPending': 'Chưa xác nhận',
}
